export function criarEstadoUploadConhecimento() {
  return {
    arquivosConhecimentoSelecionados: [],
    conhecimentoDragAtivo: false
  }
}

export function onSelecionarArquivosConhecimento(event) {
  const files = event && event.target && event.target.files ? Array.from(event.target.files) : []
  this.definirArquivosConhecimento(files)
}

export function onArrastarArquivosConhecimento(ativo) {
  if (this.conhecimentoUploading) {
    return
  }

  this.conhecimentoDragAtivo = ativo
}

export function onSoltarArquivosConhecimento(event) {
  this.conhecimentoDragAtivo = false
  if (this.conhecimentoUploading) {
    return
  }

  const files = event && event.dataTransfer && event.dataTransfer.files
    ? Array.from(event.dataTransfer.files)
    : []
  this.definirArquivosConhecimento(files)
}

export function definirArquivosConhecimento(files) {
  this.arquivosConhecimentoSelecionados = Array.isArray(files) ? files : []
}

export function removerArquivoConhecimentoSelecionado(index) {
  this.arquivosConhecimentoSelecionados = this.arquivosConhecimentoSelecionados.filter((_, i) => i !== index)
  if (!this.arquivosConhecimentoSelecionados.length && this.$refs.inputKnowledgeFile) {
    this.$refs.inputKnowledgeFile.value = ''
  }
}

export function arquivoConhecimentoKey(arquivo, index) {
  return `${arquivo.name}-${arquivo.size}-${arquivo.lastModified || index}`
}

export function textoResumoArquivosConhecimento() {
  const total = this.arquivosConhecimentoSelecionados.length
  return total === 1 ? '1 arquivo para importar' : `${total} arquivos para importar`
}
